export default {
  data: () => ({
    loading: false,
  }),
  methods: {
    proxyClick(event) {
      this.$emit('click', {
        wait: (...args) => {
          this.loading = true;
          return event.wait(...args)
            .finally(() => { this.loading = false; });
        },
        start: (...args) => {
          this.loading = true;
          event.start(...args);
        },
        complete: (...args) => {
          event.complete(...args);
          this.loading = false;
        },
      });
    },
  },
};
